<template>
  <ContentWrapper>
    <div class="file-search">
        <div class="info-box">
            <div class="setting-box">
                <span class="title">변경 항목 설정</span>
                <div class="setting-top">
                  <div class="setting-item">
                    <div class="setting-title">콘텐츠용도</div>
                    <b-form-select v-model="conOption" :options="purpTypeCd"></b-form-select>
                  </div>
                  <div class="setting-item">
                    <div class="setting-title">노출대상</div>
                    <div class="setting-title-box">
                        <input type="checkbox" class="ml-1" name="teacherUseYn" v-model="searchValue.teacherUseYn">
                        <label class="form-check-label ml-1">교사사용</label>
                        <input type="checkbox" class="ml-1" name="tutorUseYn" v-model="searchValue.tutorUseYn">
                        <label class="form-check-label ml-1">강사사용</label>
                        <input type="checkbox" class="ml-1" name="studentUseYn" v-model="searchValue.studentUseYn">
                        <label class="form-check-label ml-1">학생사용</label>
                    </div>
                  </div>
                </div>
                <div class="setting-bottom">
                  <div class="setting-item">
                    <div class="setting-title">유료여부</div>
                    <div>
                      <input type="checkbox" class="ml-1" name="payYn" v-model="searchValue.payYn">
                      <label class="form-check-label ml-1">무료</label>
                      <div>※ 체크하면 유료로 전환됩니다.</div>
                    </div>
                  </div>
                  <!-- <div class="setting-item">
                    <div class="setting-title">노출여부</div>
                    <div class="setting-title-box">
                        <input type="checkbox" class="ml-1" name="delYn" @click="searchValue.delYn = true ? false : true" v-model="searchValue.delYn">
                        <label class="form-check-label ml-1">노출</label>
                        <input type="checkbox" class="ml-1" name="delYn" @click="searchValue.delYn = true ? false : true" v-model="searchValue.delYn">
                        <label class="form-check-label ml-1">비노출</label>
                    </div>
                  </div> -->
                </div>
            </div>
        </div> 
      <div class="card-body">
        <div class="form-row align-items-center">
          <!-- 항목 검색 -->
        </div>
      </div>
    </div>
    <div div class="content-heading mt-1">
        <div class="fw-bold">개체목록</div>
    </div>
    <div class="card card-default">
      <div class="card-body">
        <form data-vv-scope="edit">
          <table class="table table-bordered">
            <colgroup>
              <col width="3%"/>
              <col width="10%"/>
              <col width="24%"/> 
              <col width="12%"/> 
              <col width="10%"/>  
              <col width="12%"/> 
              <col width="8%"/>
              <col width="20%"/>
            </colgroup>
            <tr>
              <td><input type="checkbox" v-model='selectedFile.all'></td>
              <td class="text-center">ID</td>
              <td class="text-center">개체명</td>
              <td class="text-center">용도</td>
              <td class="text-center">노출대상</td>
              <td class="text-center">유료여부</td>
              <td class="text-center">확장자</td>
              <td class="text-center">수정일</td>
            </tr>

          <tr v-for="(item, index) in filedata" :key="index">
            <td input-type><input type="checkbox" v-model='selectedFile.data' :value="index"></td>
            <td>{{ item.fileSeq }}</td>
            <td>{{ item.dispFileNm }}</td>
            <td>{{ getPurpTypeName(item.purpTypeCd)}}</td>
            <td>
              <div class="file-kind-wrap">
                <div class="file_kind">
                  <span v-show="item.teaher_use_yn != null ? true : false " :style="{color: checkColor(item.teaher_use_yn)}">{{item.teaher_use_yn}}</span>
                  <span v-show="item.teacherUseYn == 'Y' ? true : false " :style="{color: item.teacherUseYn == 'Y' ? '#FF0000' : '' }">교사</span>
                  <span v-show="item.tutorUseYn == 'Y' ? true : false "   :style="{color: item.tutorUseYn == 'Y' ? '#708090' : '' }">강사</span>
                  <span v-show="item.studentUseYn == 'Y' ? true : false " :style="{color: item.studentUseYn == 'Y' ? '#800000' : '' }">학생</span>
                </div>
              </div>
            </td>
            <td>{{ item.payYn }}</td>
            <td>{{ item.ext }}</td>
            <td>{{ item.updDt }}</td>
          </tr>
          </table>
        </form>
      </div>
    </div>
      <div class="justify-content-end d-flex mt-3">
          <button class="btn btn-secondary mr-2 modal-cancel" @click="popupClose(); ">닫기</button>
          <button class="btn btn-primary" @click="save(conOption,searchValue)">변경 저장</button>
      </div>
    <!-- // 상세 -->
    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>
</template>
<script>
import {reactive, ref, computed, onMounted, onUnmounted, onBeforeMount} from '@vue/composition-api';
import {getCsFileList, getCsFileItem, saveCsFile, deleteCsFile,saveCsFileList} from "@/api/cs/CsFileApi";
import * as momentMappingApi from "@/api/exhibit/moment/MomentMappingApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import {dataObject, purpTypeCd, getPurpTypeName} from "@/utils/Constants";
import SchDateRange from "../../../components/Common/SchDateRange";
import SchText from "../../../components/Common/SchText";
import Datepicker from 'vuejs-datepicker';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {SchDateRange, SchText, Pagenation, Datepicker, Loading},
  props: {
    extFileId: '',
    filedata:'',
    atrbInfo:'',
    title:'',
    contSeq : '',
  },
  setup(props, context) {
    const isSaved = ref(false);
    const modalLoading = ref(false);

    const conOption = ref('');
    const _dataObject = _.cloneDeep(dataObject);
    const data = reactive(_dataObject);

    const searchValue = {
      teacherUseYn : false,
      tutorUseYn : false,
      studentUseYn : false,
      payYn: false,
      delYn: false,
    };

    const selectedFile = reactive({
      data:[], 
      all:computed({
        get() {
          //console.log('selectedFiles:', selectedFile.data);
          //console.log('filedata:', props.filedata);
          return selectedFile.data.length == props.filedata.length;
        },
        set(newValue) {
          selectedFile.data.splice(0, selectedFile.data.length);
          if (newValue) {
            props.filedata.forEach((_, index) => {selectedFile.data.push(index)});
          }
        }
      })
    });

    const popupClose = () => {
      context.emit('modal-state', '3');
      if (isSaved.value) {
        context.emit('refresh',{
          version : '3',
          contSeq : props.contSeq,
        });
      }
    }

    const checkColor = (item) =>{
      switch(item){
        case 209001 : "#008000";
        break;
        case 209002 : "#0000FF";
        break;
        case 209003 : "#800080";
        break;
        case 209004 : "#FF8C00";
        break;
        case 209005 : "#FF00FF";
        break;
      }
    };

    const retVals = {
      isSaved,
      modalLoading,
      conOption,
      searchValue,
      data,
      selectedFile,
      popupClose,
      checkColor,
      purpTypeCd,
      getPurpTypeName,
      ...methods(props),
    }

    onMounted(() => {
      retVals.search();
    })

    return retVals;
  },
}

function methods(props) {

  // 목록
  async function search() {
    // props.filedata 그대로 사용한다.
  }

  // 저장
  async function save(conOption,searchValue) {
    if(this.selectedFile.data.length == 0 ){
      alert("변경할 개체를 선택해주세요.");
      return false;
    }

    switch(conOption){
      case 'content1' : conOption = "209001";
      break;
      case 'content2' : conOption = "209002";
      break;
      case 'content3' : conOption = "209003";
      break
      case 'content4' : conOption = "209004";
      break;
      case 'content5' : conOption = "209005";
      break;
    }

    let csFileList = [];
    let csMppFileList = [];
    const teacherUseYn = this.searchValue.teacherUseYn ? 'Y' : 'N';
    const tutorUseYn = this.searchValue.tutorUseYn ? 'Y' : 'N';
    const studentUseYn = this.searchValue.studentUseYn ? 'Y' : 'N';
    const payYn = this.searchValue.payYn ? 'Y' : 'N';
    const purpTypeCd = conOption;
    
    const selectedIndexes = this.selectedFile.data;
    selectedIndexes.forEach((fileIndex) => {
      const row = props.filedata[fileIndex];
      const csFile = {
        fileSeq: row.fileSeq,
        teacherUseYn:  teacherUseYn,
        tutorUseYn: tutorUseYn,
        studentUseYn: studentUseYn,
      }
      const csMppFile = {
        mappingSeq: row.mappingSeq, 
        payYn: payYn,
        //delYn: searchValue.delYn == true ? 'Y' : 'N' ,
        purpTypeCd : purpTypeCd,
        playStartTime: row.playStartTime,
        playEndTime: row.playEndTime,
        orderNum: row.orderNum,
      }
      console.log('csFile param:', csFile);
      console.log('csMppFile param:', csMppFile);
      csFileList.push(csFile);
      csMppFileList.push(csMppFile);
    });
    
    this.modalLoading = true;
    await saveCsFileList(csFileList);
    await momentMappingApi.saveMomentFileMappingList(csMppFileList);
    this.modalLoading = false;

    // 현재 테이블을 저장된 값으로 변경
    console.log('selectedIndexes', selectedIndexes);
    props.filedata.forEach((item, index) => {
      if (selectedIndexes.includes(index)) {
        const row = props.filedata[index];
        row.teacherUseYn = teacherUseYn;
        row.tutorUseYn = tutorUseYn;
        row.studentUseYn = studentUseYn;
        row.payYn = payYn;
        row.purpTypeCd = purpTypeCd;
      }
    });

    this.isSaved = true;
    this.search();
  }

  return {search, save}
}


</script>